/**
 * Calculate dose per kg of patient
 * @param {Number} dose total dose
 * @param {Number} weight of patient
 * @return {number}
 */
import {isNull} from "@/utils/formatting";

export const calculateDosePerKg = (dose, weight) => {
      if (isNull(dose) || isNull(weight)) { return NaN;}
      return (dose / weight).toFixed(2);
};

export const MAJOR_SURGERY = 'major_surgery';
export const MINOR_SURGERY = 'minor_surgery';
export const TOOTH_EXTRACTION = 'tooth_extraction';
export const MAJOR_SURGERY_ID = 44;
export const MINOR_SURGERY_ID = 23;
export const TOOTH_EXTRACTION_ID = 1;